import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background text-text">
      <header className="sticky top-0 z-40 border-b border-black/5 bg-white/85 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4 lg:px-8">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo.png" alt="AuthWorka" className="h-10 w-auto" />
            <span className="text-lg font-black text-primary">AuthWorka</span>
          </Link>

          <div className="flex items-center gap-3">
            <Link
              to="/privacy-policy"
              className="text-sm font-medium text-muted transition hover:text-primary"
            >
              Privacy Policy
            </Link>
            <Link
              to="/register"
              className="rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white"
            >
              Get started
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-12 lg:px-8">
        <div className="rounded-[2rem] border border-black/5 bg-white p-8 shadow-sm sm:p-12">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary">
            Legal
          </p>
          <h1 className="mt-3 text-4xl font-black tracking-tight">Terms & Conditions</h1>
          <p className="mt-4 text-sm text-muted">
            Effective date: {new Date().getFullYear()}
          </p>

          <div className="mt-10 space-y-8 text-sm leading-7 text-muted">
            <section>
              <h2 className="text-xl font-bold text-text">1. Introduction</h2>
              <p className="mt-2">
                Welcome to AuthWorka. These Terms & Conditions govern your access to and use
                of the AuthWorka platform, including account registration, profile creation,
                worker discovery, offers, contracts, notifications, learning resources,
                and support tools.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">2. Eligibility</h2>
              <p className="mt-2">
                By using AuthWorka, you confirm that the information you provide is accurate
                and that you are legally permitted to use the platform and enter into
                agreements through it.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">3. User Roles</h2>
              <p className="mt-2">
                AuthWorka may support different user roles, including customers, domestic
                workers, agents, and admins. Your access to certain features depends on your
                role and account status.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">4. Account Responsibility</h2>
              <p className="mt-2">
                You are responsible for maintaining the confidentiality of your account
                credentials and for all activity that occurs under your account.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">5. Profile Information</h2>
              <p className="mt-2">
                You agree to provide truthful, current, and complete profile information.
                False, misleading, or incomplete information may lead to suspension,
                moderation, or removal from the platform.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">6. Offers and Contracts</h2>
              <p className="mt-2">
                AuthWorka may provide tools for sending offers, negotiating terms, and
                managing contracts. Users are responsible for reviewing the details of any
                agreement before acceptance.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">7. Learning Resources and Digital Content</h2>
              <p className="mt-2">
                AuthWorka may provide free or paid learning resources, including downloadable
                files, videos, training materials, and protected links. Access to paid content
                is only granted after successful payment verification. Users may not reproduce,
                resell, redistribute, or misuse protected digital content.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">8. Acceptable Use</h2>
              <p className="mt-2">
                You agree not to misuse the platform, interfere with its operation, submit
                fraudulent content, impersonate others, or use the service in a way that harms
                other users or the platform.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">9. Verification and Moderation</h2>
              <p className="mt-2">
                AuthWorka may use KYC, guarantor handling, vetting, moderation, dispute
                resolution, complaint review, and account restrictions to maintain platform
                integrity and safety.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">10. Suspension or Termination</h2>
              <p className="mt-2">
                We may suspend, restrict, or terminate access to accounts that violate these
                terms, present safety concerns, or misuse the platform.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">11. Limitation</h2>
              <p className="mt-2">
                AuthWorka provides tools to help structure hiring, workforce management,
                and access to training resources, but users remain responsible for their
                decisions, agreements, and interactions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">12. Changes to These Terms</h2>
              <p className="mt-2">
                We may update these Terms & Conditions from time to time. Continued use of the
                platform after updates means you accept the revised terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">13. Contact</h2>
              <p className="mt-2">
                For questions about these Terms & Conditions, please contact the AuthWorka
                team through the platform support channels.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}